/** @returns a promise which resolves after one full tick of the event loop */
export const tick = () => new Promise(accept => setImmediate(accept));
